export default "__VITE_ASSET__3Ju30SxL__"